// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".domain-list-tooltip{max-width:360px}.domain-list-tooltip-content{white-space:pre-line;line-height:1.6;max-height:300px;overflow-y:auto}", ""]);
// Exports
module.exports = exports;
